module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Billing Location")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.addEditCard) ? _c('b-card', {
    staticClass: "gutr"
  }, [_c('b-row', {
    staticClass: "align-items-end"
  }, [(_vm.BillingLocation.TypeofAdd != 'Branch Pridel Billing Master') ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('h5', [_vm._v("Update " + _vm._s(_vm.BillingLocation.branchName) + " Branch Details")])]) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Name\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "billingLocation",
      "name": "billingLocation",
      "disabled": _vm.BillingLocation.billingLocationId ? true : false,
      "placeholder": "Location Name"
    },
    model: {
      value: (_vm.BillingLocation.billingLocation),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "billingLocation", $$v)
      },
      expression: "BillingLocation.billingLocation"
    }
  }), _vm._v(" "), (!_vm.BillingLocation.billingLocation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.billingLocation) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Location Code\n                  "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "LocCode",
      "name": "LocCode",
      "placeholder": "Location Code"
    },
    model: {
      value: (_vm.BillingLocation.LocCode),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "LocCode", $$v)
      },
      expression: "BillingLocation.LocCode"
    }
  }), _vm._v(" "), (!_vm.BillingLocation.LocCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.LocCode) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), (_vm.BillingLocation.TypeofAdd == 'Branch Pridel Billing Master') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Multi-Branch\n                  "), _c('span', {
    staticClass: "error"
  })]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "options": _vm.$store.getters['common/getAllMultiBranchList'],
      "selected-options": _vm.items,
      "placeholder": "Select Multi-Branch",
      "multiple": true
    },
    on: {
      "select": _vm.SelectMultiBranch
    },
    model: {
      value: (_vm.BillingLocation.multibranch),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "multibranch", $$v)
      },
      expression: "BillingLocation.multibranch"
    }
  }), _vm._v(" "), (!_vm.BillingLocation.multibranch) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.multibranch) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  State\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllStateList'],
      "option-value": "stateId",
      "option-text": "stateName",
      "placeholder": "Select State "
    },
    on: {
      "input": function($event) {
        _vm.getGSTCode(_vm.BillingLocation.fk_state_id)
      }
    },
    model: {
      value: (_vm.BillingLocation.fk_state_id),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "fk_state_id", $$v)
      },
      expression: "BillingLocation.fk_state_id"
    }
  }), _vm._v(" "), (!_vm.BillingLocation.fk_state_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.fk_state_id) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), (_vm.BillingLocation.fk_state_id) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  City\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllCityList'],
      "option-value": "city_id",
      "option-text": "city_name",
      "placeholder": "Select City "
    },
    model: {
      value: (_vm.BillingLocation.fk_city_id),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "fk_city_id", $$v)
      },
      expression: "BillingLocation.fk_city_id"
    }
  }), _vm._v(" "), (!_vm.BillingLocation.fk_city_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.fk_city_id) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  PIN Code\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "PinCode",
      "name": "PinCode",
      "placeholder": "PIN Code"
    },
    model: {
      value: (_vm.BillingLocation.PinCode),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "PinCode", $$v)
      },
      expression: "BillingLocation.PinCode"
    }
  }), _vm._v(" "), (!_vm.BillingLocation.PinCode) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.PinCode) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("\n                  Address\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "address",
      "name": "address",
      "placeholder": "Address"
    },
    model: {
      value: (_vm.BillingLocation.address),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "address", $$v)
      },
      expression: "BillingLocation.address"
    }
  }), _vm._v(" "), (!_vm.BillingLocation.address) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.address) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  GST No.(AAAAA1234A1Z5)\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "gstCode",
      "id": "gstCode",
      "disabled": "",
      "placeholder": "GST Code"
    },
    model: {
      value: (_vm.BillingLocation.gstCode),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "gstCode", $$v)
      },
      expression: "BillingLocation.gstCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "GSTN",
      "id": "GSTN",
      "placeholder": "GST No"
    },
    on: {
      "keyup": function($event) {
        _vm.GSTNValid()
      }
    },
    model: {
      value: (_vm.BillingLocation.GSTN),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "GSTN", $$v)
      },
      expression: "BillingLocation.GSTN"
    }
  }), _vm._v(" "), (!_vm.BillingLocation.GSTN || _vm.errorList.GSTN) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                      " + _vm._s(_vm.errorList.GSTN) + "\n                    ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  PAN(AAAAA1234A)\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "panNO",
      "id": "panNO",
      "placeholder": "PAN NO"
    },
    on: {
      "keyup": function($event) {
        _vm.PANValid()
      }
    },
    model: {
      value: (_vm.BillingLocation.panNO),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "panNO", $$v)
      },
      expression: "BillingLocation.panNO"
    }
  }), _vm._v(" "), (!_vm.BillingLocation.panNO || _vm.errorList.panNO) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.panNO) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  TAN(AAAAA1234A)\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "TAN",
      "id": "TAN",
      "placeholder": "TAN NO"
    },
    on: {
      "keyup": function($event) {
        _vm.TANValid()
      }
    },
    model: {
      value: (_vm.BillingLocation.TAN),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "TAN", $$v)
      },
      expression: "BillingLocation.TAN"
    }
  }), _vm._v(" "), (!_vm.BillingLocation.TAN || _vm.errorList.TAN) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.TAN) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  CIN\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "CIN",
      "id": "CIN",
      "placeholder": "CIN NO"
    },
    model: {
      value: (_vm.BillingLocation.CIN),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "CIN", $$v)
      },
      expression: "BillingLocation.CIN"
    }
  }), _vm._v(" "), (!_vm.BillingLocation.CIN) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.CIN) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Email\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "emailId",
      "name": "emailId",
      "placeholder": "Email ID"
    },
    on: {
      "input": function($event) {
        _vm.checkEmailID()
      }
    },
    model: {
      value: (_vm.BillingLocation.emailId),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "emailId", $$v)
      },
      expression: "BillingLocation.emailId"
    }
  }), _vm._v(" "), (!_vm.BillingLocation.emailId || _vm.errorList.emailId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.emailId) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Tele. No.\n                  "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "Telephone",
      "name": "Telephone",
      "placeholder": "Telephone No"
    },
    model: {
      value: (_vm.BillingLocation.Telephone),
      callback: function($$v) {
        _vm.$set(_vm.BillingLocation, "Telephone", $$v)
      },
      expression: "BillingLocation.Telephone"
    }
  }), _vm._v(" "), (!_vm.BillingLocation.Telephone) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorList.Telephone) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), (_vm.BillingLocation.TypeofAdd == 'Branch Pridel Billing Master') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("\n                  Status :\n                  "), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "id": 'approval' + _vm.BillingLocation.isBillingLocationActive,
      "name": "approval",
      "value": _vm.BillingLocation.isBillingLocationActive == true ? true : false
    },
    on: {
      "change": function($event) {
        _vm.activateBillingLocation()
      }
    }
  }, [_c('h6', [_c('b-badge', {
    attrs: {
      "variant": _vm.BillingLocation.isBillingLocationActive == 1 ? 'success' : 'danger'
    }
  }, [_vm._v(_vm._s(_vm.BillingLocation.isBillingLocationActive == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "margin-bottom": "0.3rem"
    },
    attrs: {
      "variant": "success",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addBillingLocation
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.BillingLocation.billingLocationId != "" ? "Update" : "Save") + "\n                  ")])], 1), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Billing Location and Code"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addEditCardFunc()
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getData('Excel')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.ExcelBtnName) + "\n                  "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.BillingLocationList,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "responsive": "",
      "primary-key": "billingLocationId"
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "billingLocationId",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                    " + _vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage) + "\n                  ")])]
      }
    }, {
      key: "billingLocation",
      fn: function(row1) {
        return [_c('span', [_c('b', [_vm._v("Name:")]), _vm._v("\n                    " + _vm._s(row1.item.billingLocation) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Code:")]), _vm._v("\n                    " + _vm._s(row1.item.LocCode) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Email ID:")]), _vm._v("\n                    " + _vm._s(row1.item.emailId) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Telephone No.:")]), _vm._v("\n                    " + _vm._s(row1.item.Telephone) + "\n                  ")])]
      }
    }, {
      key: "LocCode",
      fn: function(row1) {
        return [_c('span', [_c('b', [_vm._v("Address:")]), _vm._v("\n                    " + _vm._s(row1.item.address) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("State:")]), _vm._v("\n                    " + _vm._s(row1.item.state_name) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("City:")]), _vm._v("\n                    " + _vm._s(row1.item.city_name) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Pin Code:")]), _vm._v("\n                    " + _vm._s(row1.item.PinCode) + "\n                  ")])]
      }
    }, {
      key: "panNO",
      fn: function(row1) {
        return [_c('span', [_c('b', [_vm._v("GST Code:")]), _vm._v("\n                    " + _vm._s(row1.item.gstCode) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("GST NO:")]), _vm._v("\n                    " + _vm._s(row1.item.GSTN) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("PAN NO:")]), _vm._v("\n                    " + _vm._s(row1.item.panNO) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("TAN NO:")]), _vm._v("\n                    " + _vm._s(row1.item.TAN) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("CIN:")]), _vm._v("\n                    " + _vm._s(row1.item.CIN) + "\n                  ")])]
      }
    }, {
      key: "branchName",
      fn: function(row3) {
        return [(row3.item.branchName) ? _c('span', _vm._l((row3.item.branchName.split(',')), function(branch_name, branch_index) {
          return _c('b-button', {
            key: branch_index,
            staticClass: "mt-2",
            staticStyle: {
              "font-size": "0.675rem"
            },
            attrs: {
              "variant": "outline-primary",
              "id": "addButtonLoader",
              "size": "sm"
            },
            on: {
              "click": function($event) {
                _vm.updateBranchDetails(branch_name, row3.item)
              }
            }
          }, [_vm._v(_vm._s(branch_name))])
        })) : _c('span', [_vm._v("NA")])]
      }
    }, {
      key: "isBillingLocationActive",
      fn: function(row3) {
        return [(_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row3.item.billingLocationId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row3.item.billingLocationId,
            "name": "approval",
            "value": row3.item.isBillingLocationActive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateUser(row3.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row3.item.isBillingLocationActive == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row3.item.billingLocationId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row3.item.isBillingLocationActive == 1 ? "Active" : "In-Active"))])], 1)])]
      }
    }, {
      key: "creationTime",
      fn: function(row3) {
        return [_vm._v(_vm._s(row3.item.creationTime))]
      }
    }, {
      key: "action",
      fn: function(row2) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.editLocation(row2.item)
            }
          }
        }, [_vm._v("Update")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68e26a2c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/masters/billingLocationMaster.vue
// module id = 2706
// module chunks = 0